// @flow

import {ApiMethods, ConcurrentStrategies} from './constants';

import type {Store as ReduxStore} from 'redux';

export type Type = $Subtype<string> | Function;

export type Types = [Type, Type, Type ];

export type ApiMethod = $Values<typeof ApiMethods>;

export type Headers = {[key: string]: string };

export type RequestBodyData = any;
export type RequestParams = {[key: string]: any };
export type ApiRequest = {|
    endpoint: string,
    cache?: boolean,
    method?: ApiMethod,
    apiRoot?: string | null,
    headers?: Headers,
    bulk?: boolean,
    concurrentStrategy?: $Values<typeof ConcurrentStrategies>,
    signal?: AbortSignal,
    TRANSPORT_REQUEST_BODY?: RequestBodyData,
    TRANSPORT_GET_PARAMS?: RequestParams,
    TRANSPORT_REQUEST_FILE?: RequestParams,
    TRANSPORT_REQUEST_PARAMS?: RequestParams,
|};

export type CallInfo<T: Types> = {|
    types: T,
    ...ApiRequest,
|};

export type UploadCallInfo<T: Types> =
    {| ...CallInfo<T>, onProgress?: (progress: ProgressEvent) => void |};

export type Action<T: Type, M> = {|type: T, ...$Exact<M> |};

export type ApiAction<T: Types, M> =
    | {|CALL_API: CallInfo<T>, ...$Exact<M> |}
    | {|PRINT_FILE: CallInfo<T>, ...$Exact<M> |}
    | {|DOWNLOAD_FILE: CallInfo<T>, ...$Exact<M> |}
    | {|UPLOAD_FILE: UploadCallInfo<T>, ...$Exact<M> |};

export type CallApi = (CallInfo<*>, apiRoot: string, ReduxStore<*, *>) => Promise<any>;

export type DownloadFile = (CallInfo<*>, apiRoot: string, ?ReduxStore<*, *>) => Promise<any>;

export type PrintFile = (CallInfo<*>, apiRoot: string, ?ReduxStore<*, *>) => Promise<Action<*, *>>;

export type UploadFile = (UploadCallInfo<*>, apiRoot: string, ReduxStore<*, *>) => Promise<any>;

export type ApiDispatch<P> = (ApiAction<*, *> & P) => Promise<*>;

export type Dispatch<P> = (action: Action<*, *> & P) => Promise<*>;

export type HandleError =
    ({ types: Types, responseData: *, response: Response, store: ReduxStore<*, *> }) => Promise<*>;

export type SuccessResponse = {
    response: {
        ok: boolean,
    },
};

export type FailResponse = {
    error: string,
};

            // @pb/generate-flow-typed Webpack Loader:
            // Duplicates all internal dependencies imports
            // to be sure all deps are parsed by this loader
            // cause Babel loader removes `import type ...`
            // and e.g. 'typedef.js' files are not included in dist
            
require("./constants");
